module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('div', {
    staticClass: "titlePage",
    attrs: {
      "id": "tp01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page03"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "titlePageTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("VIOLENT POLITICS")])]), _vm._v(" "), _c('p', {
    staticClass: "titlePageSubtitle"
  }, [_vm._v("A HISTORY OF"), _c('br'), _vm._v(" INSURGENCY,"), _c('br'), _vm._v(" TERRORISM &"), _c('br'), _vm._v(" GUERRILLA WAR,"), _c('br'), _vm._v(" FROM THE "), _c('br'), _vm._v("AMERICAN "), _c('br'), _vm._v("REVOLUTION "), _c('br'), _vm._v("TO IRAQ")]), _vm._v(" "), _c('h2', {
    staticClass: "titlePageAuthor"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("WILLIAM R. POLK")])]), _vm._v(" "), _c('p', {
    staticClass: "titlePageLogo"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "logo.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page04"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page05"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedicationTextCenter"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OR")]), _vm._v(" E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LISABETH WITH LOVE")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page06"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "contentsHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "fm_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction#fm01"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01#ch01"
    }
  }, [_vm._v("1 The American Insurgency")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 The Spanish "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Guerrilla")]), _vm._v(" Against the French")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 The Philippine “Insurrection”")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Irish Struggle for Independence")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Tito and the Yugoslav Partisans")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Greek Resistance")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Kenya and the Mau Mau")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The Algerian War of National Independence")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 The Vietnamese Struggle Against the French")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 America Takes Over from France in Vietnam")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Afghan Resistance to the British and the Russians")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "bm_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/conclusion#bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Very Expensive School")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "en_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/notes#en01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "bm_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/searchableterms#bm02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Searchable Terms")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ack_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgments#ack01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ata_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor#ata01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "rev_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/praise#rev01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "adc_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/otherbooks#adc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Books by William R. Polk")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/copyright#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/aboutthepublisher#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-161e0316","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/violentpolitics.vue
// module id = 60
// module chunks = 0